<div class="btn-group" role="group">
  <ng-content></ng-content>
</div>
